module.exports = __webpack_public_path__ + "5f204be0cd90957ad9f8d0860b913b46.png";